import VioReportIndex from '@/views/vioReport/VioReportIndex'
import ReportDetail from '@/views/vioReport/ReportDetail'
import ReportType from '@/views/vioReport/ReportType'
import ReportMain from '@/views/vioReport/ReportMain'
import ReportNotice from '@/views/vioReport/ReportNotice'
// import Login from '@/views/demo/login'
import VioIndex from '@/views/vioReport/index'
import Repair from '@/views/vioReport/repaire'
import reportSupplement from '@/views/vioReport/reportSupplement'
import RewardBank from '@/views/vioReport/RewardBank'
const routes = [
  // 中转页面
  {
    path: '/', // 正常使用入口页面 恢复要去掉repair
    name: 'vioIndex',
    component: VioIndex
  },
  // 前端包
  {
    path: '/vioReportIndex',
    name: 'vioReportIndex',
    component: VioReportIndex
  },
  {
    path: '/reportDetail',
    name: 'reportDetail',
    component: ReportDetail
  },
  {
    path: '/repair',
    name: 'repair',
    component: Repair
  },
  {
    path: '/reportType',
    name: 'reportType',
    component: ReportType
  },
  {
    path: '/reportMain',
    name: 'reportMain',
    component: ReportMain
  },
  {
    path: '/reportNotice',
    name: 'reportNotice',
    component: ReportNotice
  },
  {
    path: '/reportSupplement',
    name: 'reportSupplement',
    component: reportSupplement
  },
  {
    path: '/rewardBank',
    name: 'rewardBank',
    component: RewardBank
  }
]
export default routes



// WEBPACK FOOTER //
// ./src/router/routes.js